import apiClient from '../clienteFebosAPI';

const RESOURCE = '/repositorios';

// REPOSITORIES
// list
export const ioRepositoriesFolderRulesList = ({
  repositoryId,
  folderId,
  filters,
  order = '+priority'
}) => {
  const params = apiClient.queryParams(
    {
      filtros: filters,
      orden: order,
    }
  );
  return apiClient.get(
    `${RESOURCE}/${repositoryId}/carpetas/${folderId}/rules?${params}`,
    { operacionId: 'io.ed.repositorios.rules.listar' }
  );
};

export const ioRepositoriesFolderRuleGet = ({ repositoryId, folderId, ruleId }) => apiClient.get(
  `${RESOURCE}/${repositoryId}/carpetas/${folderId}/rules/${ruleId}`,
  { operacionId: 'io.ed.repositorios.rule.obtener' }
);

export const ioRepositoriesFolderRulePost = ({ repositoryId, folderId }, state) => apiClient.post(
  `${RESOURCE}/${repositoryId}/carpetas/${folderId}/rules/`,
  state,
  { operacionId: 'io.ed.repositorios.rule.save' }
);

export const ioRepositoriesFolderRuleDelete = (
  {
    repositoryId,
    folderId,
    ruleId
  }
) => apiClient.delete(
  `${RESOURCE}/${repositoryId}/carpetas/${folderId}/rules/${ruleId}`,
  { operacionId: 'io.ed.repositorios.rule.delete' }
);

export const ioRepositoriesFolderRuleUpdate = (
  {
    repositoryId,
    folderId,
    ruleId
  },
  body
) => apiClient.put(
  `${RESOURCE}/${repositoryId}/carpetas/${folderId}/rules/${ruleId}`,
  body,
  { operacionId: 'io.ed.repositorios.rule.update' }
);
